import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const terms = lazy(() => import("./Terms"));

const TERMS_ROUTES: RouteObject[] = [
  {
    path: "/public/terms",
    element: React.createElement(terms),
  },
];

export default TERMS_ROUTES;
